<sb-dialog-activation>
  <chapter-step
    main-panel
    [title]="'🎉 ' + ('Nice! Time Tracking is ready.' | translate)"
    [nextButtonLabel]="chapterCTAs?.primary?.label || 'Continue exploring' | translate"
    (next)="close({ action: 'primary' })"
  >
    <p class="m-0 text-base">
      {{
        "You can customize it further to suit your team's needs, or start inviting employees now. With accurate hour tracking, you'll save time, stay on top of work, and make payroll a breeze."
          | translate
      }}
      <a [href]="'timesheet' | knowledgeBaseArticleLink" target="_blank" class="font-bold text-brand">
        {{ 'Learn more' | translate }}
      </a>
    </p>
  </chapter-step>
  <div
    class="size-full rounded-lg bg-cover bg-center bg-no-repeat lg:mr-12"
    aside-panel
    [ngStyle]="{
      backgroundImage: 'url(assets/images/onboarding/chapters/time-tracking.jpg)'
    }"
  ></div>
</sb-dialog-activation>
